//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import OnePageLinkAndButton from '@components/one-page/OnePageLinkAndButton';
import { ReportCover } from '@components/reports/ReportCover';
import { ReportSectionCover } from '@components/reports/ReportSectionCover';
import { ReportTableOfContents } from '@components/reports/ReportTableOfContents';
import Cuid from '@models/Cuid';
import makeAngularReactControllerWithScope from '@react-bridge/angular-react-widget-with-scope';
import StreamsDrawerCarousel from '@streams-drawer/streams-drawer-content/streams-drawer-moderation-content/StreamsDrawerCarousel';
import StreamsDrawerModerationList from '@streams-drawer/streams-drawer-content/streams-drawer-moderation-content/StreamsDrawerModerationList';

angular.module('curalate').component('reportCover', {
  bindings: {
    reportTitle: '<',
    clientName: '<',
  },
  controller: makeAngularReactControllerWithScope(
    (scope: { $ctrl: React.ComponentProps<typeof ReportCover> }) => {
      return (
        <ReportCover
          reportTitle={scope.$ctrl.reportTitle}
          clientName={scope.$ctrl.clientName}
        />
      );
    },
  ),
});

angular.module('curalate').component('reportSectionCover', {
  bindings: {
    reportSectionTitle: '@',
  },
  controller: makeAngularReactControllerWithScope(
    (scope: { $ctrl: React.ComponentProps<typeof ReportSectionCover> }) => {
      return (
        <ReportSectionCover
          reportSectionTitle={scope.$ctrl.reportSectionTitle}
        />
      );
    },
  ),
});

angular.module('curalate').component('reportTableOfContents', {
  bindings: {
    contents: '<',
    customTitle: '@?',
  },
  controller: makeAngularReactControllerWithScope(
    (scope: { $ctrl: React.ComponentProps<typeof ReportTableOfContents> }) => {
      return (
        <ReportTableOfContents
          contents={scope.$ctrl.contents}
          customTitle={scope.$ctrl.customTitle}
        />
      );
    },
  ),
});

angular.module('uia').component('onePageLinkAndButton', {
  bindings: {
    cuid: '<',
  },
  controller: makeAngularReactControllerWithScope(
    (scope: {
      $ctrl: {
        cuid: Cuid;
      };
    }) => {
      return <OnePageLinkAndButton cuid={Cuid(scope.$ctrl.cuid)} />;
    },
  ),
});

angular.module('curalate').component('streamsDrawerModerationList', {
  transclude: true,
  bindings: {
    items: '<',
    layout: '<',
    disableBulkActions: '<',
    disableRejection: '<',
  },
  controller: makeAngularReactControllerWithScope(
    ({
      $ctrl,
    }: {
      $ctrl: React.ComponentProps<typeof StreamsDrawerModerationList>;
    }) => {
      return (
        <StreamsDrawerModerationList
          layout={$ctrl.layout}
          items={$ctrl.items}
          disableBulkActions={$ctrl.disableBulkActions}
          disableRejection={$ctrl.disableRejection}
        />
      );
    },
  ),
});

angular.module('curalate').component('streamsDrawerCarousel', {
  transclude: true,
  bindings: {
    items: '<',
    imageSize: '<',
  },
  controller: makeAngularReactControllerWithScope(
    ({
      $ctrl,
    }: {
      $ctrl: React.ComponentProps<typeof StreamsDrawerCarousel>;
    }) => {
      return (
        <StreamsDrawerCarousel
          items={$ctrl.items}
          imageSize={$ctrl.imageSize}
        />
      );
    },
  ),
});
